module.exports = __webpack_public_path__ + "img/Team_mitte.4f69114a.jpg";